import useSWR from 'swr';
import swrConfig from 'utils/swrConfig';
import { getAppStatus } from '../fetchers/get-app-status';

export const useAppStatusSWR = () => {
    const { data, isLoading, error, mutate } = useSWR('app-status', getAppStatus, swrConfig);

    return { data, isLoading, error, mutate };
};
